<template>
  <div class="main">
    <div class="outer-container">
      <div class="back" style="margin-bottom: 2.5rem;position: relative;bottom: 1px;letter-spacing: -0.3px;">
        <router-link style="position: relative; bottom: 1px;" to="./">back</router-link>
      </div>
      <!-- Button to edit document in dashboard -->
      <prismic-edit-button :documentId="documentId"/>

      <h1 class="blog-title" id="blog-post-title" style="padding-bottom: 6.7rem !important;padding-top: 6.25rem !important;line-height: 1 !important;letter-spacing: -1.2px;">{{ $prismic.richTextAsPlain(fields.title) }}</h1>
      <p class="blog-post-meta" style="display: none;padding-bottom: 0rem;padding-top: 2.25rem;padding-right: 0.4rem;font-size: 28px !important;font-weight: 900;margin-bottom: -2.75rem;text-align: center;color: rgb(50, 50, 50);letter-spacing: -0.7px;">{{ Intl.DateTimeFormat('en-US', dateOptions).format(new Date(fields.date)).replace('1969', '') }}</span></p>

    </div>
    <!-- Slice Block Componenet tag -->
    <slices-block :slices="slices"/>
  </div>
</template>

<script>
//Importing all the slices components
import SlicesBlock from '../components/SlicesBlock.vue'

export default {
  name: 'post',
  components: {
    SlicesBlock
  },
  data () {
    return {
      dateOptions: { year: 'numeric' },
      documentId: '',
      fields: {
        title: null,
        date: null,
      },
      slices: []
    }
  },
  methods: {
    getContent (uid) {
      //Query to get post content
      this.$prismic.client.getByUID('post', uid)
        .then((document) => {
          if (document) {
            this.documentId = document.id
            this.fields.title = document.data.title
            this.fields.date = document.data.date
            
            //Set slices as variable
            this.slices = document.data.body
          } 
          else {
            //returns error page
            this.$router.push({ name: 'not-found' })
          }
        })
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
}
</script>

<style>
.post-part.single a {
  text-decoration: none;
  background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.8) 75%);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 0.8) 75%);
  background-repeat: repeat-x;
  background-size: 2px 2px;
  background-position: 0 23px;
}
.blog-post-meta {
  color: #9A9A9A;
  font-family: 'colfax-web-bold', sans-serif !important;
  margin-bottom: 8px;
}

/* Media Queries */
@media (max-width: 767px) {
  .post-part pre {
    font-size: 14px;
  }
  .blog-post-meta {
    font-size: 16px;
    padding-bottom: 0rem !important;
    margin-bottom: -3.75rem;
    text-align: right;
    padding-top: .25rem;
    padding-right: .75rem;
  }
  #blog-post-title {
    margin-bottom: -2.5rem !important;
    margin-top: -2.5rem !important;
  }
}

@media screen and (min-width: 768px) {
  .blog-post-meta {
    font-size: 16px;
  }
}
</style>
